import { createContext, useContext, useState } from "react";

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem("wc_ei_lang") || "fr");

  const toggleLang = () => {
    const next = lang === "fr" ? "en" : "fr";
    localStorage.setItem("wc_ei_lang", next);
    setLang(next);
  };

  return <LangContext.Provider value={{ lang, toggleLang }}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
